import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { ResponsiveBar } from '@nivo/bar';

const BAR_WIDTH = 16; // px, tweak as needed

const DailyPnLBarChart = ({ data, label }) => {
    const chartWidth = Math.max(data.length * BAR_WIDTH, 400); // 400px min width
    const scrollRef = useRef();

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollLeft = scrollRef.current.scrollWidth;
        }
    }, [data.length]);

    return (
        <div ref={scrollRef} style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden' }}>
            <div style={{ width: chartWidth, minWidth: '100%', height: '25vh' }}>
                <ResponsiveBar
                    data={data}
                    keys={['totalNetPnLPerDay']}
                    indexBy="date"
                    margin={{ top: 0, right: 0, bottom: 0, left: 50 }}
                    valueFormat={(v) => v.toFixed(2)}
                    tooltipLabel={(p) => <span>{`${label} - ${p.data.date}`}</span>}
                    padding={0.7} // Lower padding for more bar width
                    borderRadius={5}
                    valueScale={{ type: 'linear' }}
                    indexScale={{ type: 'band', round: true }}
                    colors={(d) => (d.data.totalNetPnLPerDay < 0 ? '#E57373' : '#29a373')}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={null}
                    axisLeft={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0
                    }}
                    enableLabel={false}
                    theme={{
                        tooltip: {
                            container: {
                                backgroundColor: '#263238D9',
                                color: '#e0e3eb',
                                fontWeight: 400,
                                borderRadius: '0.5rem',
                                padding: '0.5rem',
                                lineHeight: 'normal',
                                fontSize: '0.75rem'
                            }
                        }
                    }}
                    legends={[
                        {
                            dataFrom: 'keys',
                            anchor: 'bottom-right',
                            direction: 'column',
                            justify: false,
                            translateX: 120,
                            translateY: 0,
                            itemsSpacing: 2,
                            itemWidth: 100,
                            itemHeight: 20,
                            itemDirection: 'left-to-right',
                            itemOpacity: 0.85,
                            symbolSize: 20,
                            effects: [
                                {
                                    on: 'hover',
                                    style: {
                                        itemOpacity: 1
                                    }
                                }
                            ]
                        }
                    ]}
                />
            </div>
        </div>
    );
};

DailyPnLBarChart.propTypes = {
    data: PropTypes.array,
    label: PropTypes.string
};

export default DailyPnLBarChart;
